var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreditCard = function SvgCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.1185,72.2985 L14.8815,72.2985 C13.5685,72.2985 12.4995,71.2305 12.4995,69.9165 L12.4995,43.7015 L83.5005,43.7015 L83.5005,69.9165 C83.5005,71.2305 82.4315,72.2985 81.1185,72.2985 M14.8815,23.7015 L81.1185,23.7015 C82.4315,23.7015 83.5005,24.7695 83.5005,26.0835 L83.5005,31.7015 L12.4995,31.7015 L12.4995,26.0835 C12.4995,24.7695 13.5685,23.7015 14.8815,23.7015 M81.1185,19.7015 L14.8815,19.7015 C11.3625,19.7015 8.4995,22.5645 8.4995,26.0835 L8.4995,69.9165 C8.4995,73.4355 11.3625,76.2985 14.8815,76.2985 L81.1185,76.2985 C84.6375,76.2985 87.5005,73.4355 87.5005,69.9165 L87.5005,26.0835 C87.5005,22.5645 84.6375,19.7015 81.1185,19.7015",
    fill: "#000000",
    fillRule: "evenodd"
  })));
};
export default SvgCreditCard;